export default __webpack_public_path__ + "static/media/4.03236fc5.jpeg";